import React from 'react';
import { bool, func } from 'prop-types';
import { Button } from '@mui/material';
import Loading from 'components/common/Loading';
import { I18n } from 'utils/i18n';

const ConfirmButton = ({ isLoading, onClick }) => (
  <Button sx={{ ml: 1, mr: 0.625 }} onClick={onClick} variant="contained" color="primary" autoFocus>
    {isLoading && <Loading sx={{ mr: 0.375 }} color="inherit" debounce={0} size={16} />}
    {I18n.t('Dialog.Send')}
  </Button>
);
ConfirmButton.propTypes = {
  isLoading: bool.isRequired,
  onClick: func.isRequired,
};

export default ConfirmButton;
